import { render, staticRenderFns } from "./robotSend.vue.js?vue&type=template&id=23ef5bf5&scoped=true!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./robotSend.vue?vue&type=template&id=23ef5bf5&scoped=true"
import script from "./robotSend.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./robotSend.vue?vue&type=script&lang=js"
export * from "./robotSend.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./robotSend.vue?vue&type=script&lang=js"
import style0 from "./robotSend.vue.scss?vue&type=style&index=0&id=23ef5bf5&lang=scss&scoped=true!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./robotSend.vue?vue&type=style&index=0&id=23ef5bf5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ef5bf5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23ef5bf5')) {
      api.createRecord('23ef5bf5', component.options)
    } else {
      api.reload('23ef5bf5', component.options)
    }
    module.hot.accept("./robotSend.vue.js?vue&type=template&id=23ef5bf5&scoped=true!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./robotSend.vue?vue&type=template&id=23ef5bf5&scoped=true", function () {
      api.rerender('23ef5bf5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/live/liveRoom/components/Dialog/robotSend.vue"
export default component.exports